import request from '../utils'

const dataspaceApi = {
    dataSpaceList: async () => {
        const req = request.get(`/api/dataspace`)
        const res = await req;
        return res.body;
    },
    tables: async (dataSpaceId) => {
        const req = request.get(`/api/dataspace/${dataSpaceId}/tables`)
        const res = await req;
        return res.body;
    },
    tableExport: (dataSpaceId, tableName) => {
        const req = request.get(`/api/dataspace/${dataSpaceId}/export/${encodeURIComponent(tableName)}`);
        return req;
    },
    tableShpExport: (dataSpaceId, tableName, query) => {
        const req = request.get(`/api/dataspace/${dataSpaceId}/export-shp/${encodeURIComponent(tableName)}?${query}`);
        return req;
    },
    dataSpaceDetail: async (dataSpace) => {
        const req = request.get(`/api/dataspace/${dataSpace}`)
        const res = await req;
        return res.body;
    },
    dataSpaceUpdate: async (dataSpace) => {
        const req = request.put(`/api/dataspace/${dataSpace.id}`).send(dataSpace);
        const res = await req;
        return res.body;
    },
    dataSpaceCreate: async (dataSpace) => {
        const req = request.post(`/api/dataspace`).send(dataSpace);
        const res = await req;
        return res.body;
    },
    dataSpaceDelete: async (dataSpaceId) => {
        const req = request.delete(`/api/dataspace/${dataSpaceId}`);
        await req;
    },
    tableDelete: async (dataSpaceId, sqlTableName) => {
        await request.delete(`/api/dataspace/${dataSpaceId}/tables/${sqlTableName}`);
    },
    importTable: async (dataSpaceId, formData) => {
        const res = await request
            .postMultipart(`/api/dataspace/${dataSpaceId}/import`)
            .send(formData);
        return res.body;
    },
    reimportTable: async (dataSpaceId, tableName, formData) => {
        const res = await request
            .postMultipart(`/api/dataspace/${dataSpaceId}/tables/${tableName}/reimport`)
            .attach('file', formData.get('file'))
            .field('delimiter', formData.get('delimiter'));
        return res.body;
    },
    reimportTableShp: async (dataSpaceId, tableName, formData) => {
        const res = await request
            .postMultipart(`/api/dataspace/${dataSpaceId}/tables/${tableName}/reimport-shp`)
            .send(formData);

        return res.body;
    }
};

export default dataspaceApi